import { GetAdminUsersRequest, GetAdminUsersResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminUsersService {
    public async getUsers(request: GetAdminUsersRequest): Promise<GetAdminUsersResult> {
        return api.admin.getUsers(request)
    }
}

export const service = new AdminUsersService()